var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLavalLogoNoText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Orig",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 39",
    style: {
      enableBackground: "new 0 0 55 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0656A5;}\n\t.st1{fill:#A7228C;}\n\t.st2{fill:#0B0B0B;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "44.3,30.4 29.7,30.4 14.9,15.6 1.1,15.6 23.5,38 51.8,38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "15.6,15.2 29.4,29 29.4,14.9 15.6,1.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "45,15.9 45,30.1 52.6,37.7 52.6,23.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.4,14.8L15.6,0L0,0v15.6l23.2,23.2h30.2V23.2L45,14.8H30.4z M30.2,15.6h14v14h-14V15.6z M15.6,1.1 l13.8,13.8V29L15.6,15.2V1.1z M0.8,0.8h14.1v14.1H0.8V0.8z M23.5,38L1.1,15.6h13.8l14.8,14.8h14.6l7.6,7.6H23.5z M45,15.9l7.6,7.6 v14.2L45,30.1V15.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    className: "st3",
    width: 14.1,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.2,
    y: 15.6,
    className: "st3",
    width: 14,
    height: 14
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLavalLogoNoText);
export default __webpack_public_path__ + "static/media/laval-logo-no-text.a8086a7618df4933811e4279a0c4ff16.svg";
export { ForwardRef as ReactComponent };